import { useQueryClient } from 'react-query';
import raydiant from '../clients/raydiant';
import { keys } from '../queryClient';
import useProtectedMutation from './useProtectedMutation';

export default function useMoveAllItemsToFolder() {
  const queryClient = useQueryClient();

  return useProtectedMutation<
    void,
    Error,
    {
      presentationIds: string[];
      playlistIds: string[];
      folderIds: string[];
      parentFolderId: string | null;
    }
  >(
    async ({ presentationIds, playlistIds, folderIds, parentFolderId }) => {
      const folderIdsWithoutCyclicDeps = folderIds.filter(
        (folderId) => folderId !== parentFolderId,
      );

      await Promise.all([
        ...presentationIds.map((id) =>
          raydiant.movePresentationToFolder(id, parentFolderId),
        ),
        ...playlistIds.map((id) =>
          raydiant.movePlaylistToFolder(id, parentFolderId),
        ),
        ...folderIdsWithoutCyclicDeps.map((id) =>
          raydiant.moveFolderToFolder(id, parentFolderId),
        ),
      ]);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(keys.library());
      },
    },
  );
}
